import { render, staticRenderFns } from "./FamilyHome.vue?vue&type=template&id=0f252791&scoped=true"
import script from "./FamilyHome.vue?vue&type=script&lang=js"
export * from "./FamilyHome.vue?vue&type=script&lang=js"
import style0 from "./FamilyHome.vue?vue&type=style&index=0&id=0f252791&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f252791",
  null
  
)

export default component.exports